import {useState, useContext, useEffect} from 'react';
import {AxiosContext} from '../components/utils/AxiosProvider';

export const useGetFiles = (ids, thing) => {
    const [files, setFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(null);
    const [error, setError] = useState(null);
    const {client: axiosClient} = useContext(AxiosContext);

    const onFilesFetched = data => {
        const results = data.map(file => file.data);
        setFiles(results);
        setError(null);
        setIsLoading(false);
    };

    const onError = (...errors) => {
        setError(errors.map(e => e.error));
        setFiles([]);
        setIsLoading(false);
    };

    const fetchFile = async () => {
        if (ids.length) {
            setIsLoading(true);
            return Promise.all(
                ids
                    .filter(id => id !== undefined)
                    .map(id => axiosClient.get(`/api/1/user/image/${id}`))
            );
        }
        return Promise.resolve();
    };

    useEffect(() => {
        if (axiosClient) {
            async function doFetch() {
                try {
                    const data = await fetchFile();
                    onFilesFetched(data);
                } catch (e) {
                    onError(e);
                }
            }
            doFetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [axiosClient]);

    return {
        files,
        isLoading,
        error,
        refetch: fetchFile,
    };
};

export default useGetFiles;
